import React, { memo, useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from 'components/ui/card';
import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';
import { emailVerify } from '@app/api';

function EmailVerification() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const onChangeCode = useCallback((value: string) => {
    if (/^\d*$/.test(value)) {
      setCode(value);
    }
  }, []);

  const handleVerify = async () => {
    setLoading(true);
    setError('');

    const email = searchParams.get('email');

    if (!email) {
      setError('Ошибка: отсутствует email');
      setLoading(false);
      return;
    }

    try {
      const response = await emailVerify({ email, code });
      alert(response.message);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Ошибка при подтверждении');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="max-w-md mx-auto mt-12 p-8 text-center">
      <CardContent>
        <h2 className="text-2xl font-semibold mb-2">Подтверждение почты</h2>
        <p className="mb-4">
          Введите код, который был отправлен на вашу почту.
        </p>
        <Input
          placeholder="Код подтверждения"
          value={code}
          onChange={(e) => onChangeCode(e.target.value)}
          className="mb-2"
          disabled={loading}
        />
        {error && <div className="text-red-600 text-sm mb-2">{error}</div>}
        <Button
          disabled={loading}
          onClick={handleVerify}
          className="w-full mt-2"
        >
          {loading ? 'Отправка...' : 'Отправить'}
        </Button>
      </CardContent>
    </Card>
  );
}

export default memo(EmailVerification);
